import React from 'react';

export default function CustomAlert({ 
  isOpen, 
  title, 
  message, 
  type = 'confirm', // 'confirm', 'success', 'error'
  onConfirm, 
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) {
  if (!isOpen) return null;

  const getAlertStyles = () => {
    switch (type) {
      case 'success':
        return {
          icon: '✓',
          iconClass: 'bg-green-100 text-green-600',
          buttonClass: 'bg-green-600 hover:bg-green-700'
        };
      case 'error':
        return {
          icon: '✕',
          iconClass: 'bg-red-100 text-red-600',
          buttonClass: 'bg-red-600 hover:bg-red-700'
        };
      default:
        return {
          icon: '⚠',
          iconClass: 'bg-yellow-100 text-yellow-600',
          buttonClass: 'bg-blue-600 hover:bg-blue-700'
        };
    }
  };

  const styles = getAlertStyles();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 modal-open-block-swipe">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full mx-4">
        <div className="p-6">
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold ${styles.iconClass}`}>
              {styles.icon}
            </div>
          </div>

          {/* Title */}
          {title && (
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">
              {title}
            </h3>
          )}

          {/* Message */}
          <p className="text-gray-600 text-center mb-6 leading-relaxed">
            {message}
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            {type === 'confirm' && (
              <button
                onClick={onCancel}
                className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
              >
                {cancelText}
              </button>
            )}
            <button
              onClick={onConfirm}
              className={`flex-1 px-4 py-3 text-white rounded-lg font-medium transition-colors duration-200 ${styles.buttonClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 